import { Slider } from '@swordhealth/ui-corporate';
import styled from 'styled-components';

export const ImagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
  width: 100%;
`;

export const ImagesWrapper = styled.div`
  width: 100%;
  height: 325px;
  max-width: 632px;
  margin: auto;
  overflow: visible;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  & > img {
    width: 230px;
    height: 272px;
    &:first-of-type {
      transform: rotate(-8deg) translateX(80px) translateY(10px);
      margin: 0;
      z-index: -1;

      @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
        transform: rotate(-6deg) translateX(180px) translateY(10px);
      }
    }
    &:nth-of-type(2) {
      z-index: 1 !important;
    }
    &:nth-of-type(3) {
      transform: rotate(8deg) translateX(-80px) translateY(10px);
      margin: 0;
      z-index: -1;

      @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
        transform: rotate(6deg) translateX(-180px) translateY(10px);
      }
    }
    &.active {
      z-index: 2 !important;
      scale: 1.2;
      animation: scaleImage 0.3s ease-out;
    }
    &:not(.active) {
      scale: 1;
      z-index: -1;
    }
  }

  @keyframes scaleImage {
    from {
      scale: 1;
    }
    to {
      scale: 1.2;
    }
  }
`;

export const CustomSlider = styled(Slider)`
  position: relative;
  & > div.swiper > .swiper-wrapper > .swiper-slide {
    & > blockquote > div:first-of-type {
      background: linear-gradient(115.5deg, #ff8383 -1.19%, #fed267 100.53%);
    }
  }

  & > div:not(.swiper) {
    & > div:first-of-type {
      height: 14px;
    }
    button {
      background-color: var(--ui-colors-secondary-400);
      border-radius: 800px;
      width: 48px;
      height: 48px;
      position: absolute;
      top: -48px;
      z-index: 9;

      @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
        top: -210px;
      }

      &[data-navigation='prev'] {
        left: 0;
      }
      &[data-navigation='next'] {
        right: 0;
      }
    }
  }
`;

export const GradientCircle = styled.div`
  width: 480px;
  height: 240px;
  opacity: 0.5;
  background: linear-gradient(140.32deg, #ff8283 14.96%, #fed267 70.39%);
  backdrop-filter: blur(200px);
  filter: blur(200px);
  position: absolute;
  top: 40px;

  @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
    width: 280px;
    background: linear-gradient(180deg, #ff8283 30%, #fed267 100%);
    backdrop-filter: blur(100px);
    filter: blur(100px);
  }

  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    display: none;
  }
`;
